import { Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})

export class ValidationService {

  constructor() { }

  // return list of error messages
  public validationMessages(controlName) {
    const messages = {
      required: 'This field is required.',
      maxlength: this.getMaxLengthErrorMessage(controlName),
      minlength: this.getMinLengthErrorMessage(controlName),
      max: this.getMaxValueMessage(controlName),
      min: this.getMinValueMessage(controlName),
      pattern: this.getPatternErrorMessage(controlName),
      confirmEmailValidation: 'Primary and Secondary Email addresses cannot be the same',
      confirmPANValidation: 'Confirm PAN and PAN fields have different values.',
      confirmTINValidation: 'Confirm TIN Number and TIN number have different values.',
      tinValidation: 'Enter a valid GSTIN number',
      salaryValidation: 'Net salary should be less than or equal to gross salary',
      confirmMobileValidation: 'Primary and Secondary Mobile numbers cannot be the same',
      nameValidation: 'Names cannot be the same',
      midNameValidation: 'Names cannot be the same',
      dateValidation: 'To Date should be greater than From',
      toDateValidation: 'From Date should not be greater than To Date',
      aadharValidation: 'Aadhar cannot be the same',
      itrIncomeValidation: 'ITR Income should be less than or equal to Annual Income',
      downpaymentMaxValidation: 'Downpayment has exceeded the Max allowed Value',
      downpaymentMinValidation: 'Downpayment Value is less than minimum value'
    };
    return messages;
  }


  getMaxLengthErrorMessage(controlName) {
    if (controlName == 'primaryMobilePhone' || controlName == 'otherMobilePhone' || controlName == 'mobilePhone1' || controlName == 'mobilePhone2') {
      return "Please enter 10 digit phone number."
    }
    else if (controlName == 'firstName' || controlName == 'middleName' || controlName == 'contactPerson' || controlName == 'referenceName1' || controlName == 'referenceName2') {
      return "Name should not exceed 30 characters."
    }
    else if (controlName == 'spouseName' || controlName == 'motherName') {
      return "Name should not exceed 60 characters."
    }
    else if (controlName == 'lastName') {
      return "Last name should not exceed 20 characters."
    }
    else if (controlName == 'aadhar') {
      return "Please enter 12 digit Aadhar number"
    }
    else if (controlName == 'currentBuildingNo' || controlName == 'currentStreetName' || controlName == 'permanentBuildingNo' || controlName == 'permanentStreetName') {
      return "Address should not exceed 40 characters."
    }
    else if (controlName == 'currentArea' || controlName == 'permanentArea') {
      return "Area should not exceed 50 characters."
    }
    else if (controlName == 'currentCity' || controlName == 'permanentCity') {
      return "City should not exceed 25 characters."
    }
    else if (controlName == 'currentPinCode' || controlName == 'permanentPinCode') {
      return "Please enter 6 digit pincode."
    }
    else if (controlName == 'panNumber' || controlName == 'confirmPANNumber') {
      return "Please enter 10 digit PAN."
    }
    else if (controlName == 'grossSalary' || controlName == 'netSalary' || controlName == 'annualIncome' || controlName == 'itrIncome') {
      return "Please enter 15 digit numeric with maximum of 2 decimal values"
    }
    else if (controlName == 'subvention' || controlName == 'additionalSubvention') {

      return "Not in Range allowed by Financial Product/Special Program"
    }
    else {
      return "Field has exceeded maximum number of characters."
    }

  }

  getMaxValueMessage(controlName) {
    if (controlName == 'subvention' || controlName == 'additionalSubvention') {
      return "Not in Range allowed by Financial Product/Special Program"
    }
    else {
      return "Field has exceeded the maximum value"
    }
  }


  getMinValueMessage(controlName) {
    if (controlName == 'subvention' || controlName == 'additionalSubvention') {
      return "Not in Range allowed by Financial Product/Special Program"
    }
    // else if (controlName == 'downPaymentAmount'|| controlName == 'downpaymentValue') {
    //   return "The downpayment is not between the highest and lowest interest rate for the selected finance product/Special program"
    //  }
    else {
      return "Field is less than minimum value"
    }
  }


  getPatternErrorMessage(controlName) {
    if (controlName == 'primaryMobilePhone' || controlName == 'otherMobilePhone' || controlName == 'phoneNum' || controlName == 'mobilePhone1' || controlName == 'mobilePhone2') {
      return "Please enter valid phone number"
    }
    else if (controlName == 'firstName' || controlName == 'middleName' || controlName == 'lastName' || controlName == 'contactPerson' || controlName == 'applicantName' || controlName == 'organisationName' || controlName == 'nameOfNominee' || controlName == 'spouseName' || controlName == 'motherName' || controlName == 'referenceName1' || controlName == 'referenceName2' || controlName == 'maidenName') {
      return "Please enter valid name"
    }
    else if (controlName == 'aadhar') {
      return "Please enter valid numeric Aadhar"
    }
    else if (controlName == 'primaryEmail' || controlName == 'secondaryEmail') {
      return "Please enter valid email ID"
    }
    else if (controlName == 'panNumber' || controlName == 'confirmPANNumber') {
      return "Please enter valid PAN"
    }
    else if (controlName == 'designation') {
      return "Please enter valid designation"
    }
    else if (controlName == 'currentPinCode' || controlName == 'permanentPinCode') {
      return "Please enter valid Pincode"
    }
    else if (controlName == 'grossSalary' || controlName == 'netSalary' || controlName == 'aproxAvgBankBal' || controlName == 'annualIncome' || controlName == 'itrIncome' || controlName == 'downpaymentValue' || controlName == 'downPaymentAmount' || controlName == 'discount') {
      return "Please enter valid amount"
    }
    else if (controlName == 'otpField1' || controlName == 'otpField2' || controlName == 'otpField3' || controlName == 'otpField4' || controlName == 'otpField5' || controlName == 'otpField6' || controlName == 'subvention' || controlName == 'additionalSubvention') {
      return "Please enter Numeric values"
    }
    else if (controlName == 'currentBuildingNo' || controlName == 'permanentBuildingNo') {
      return "No special characters allowed"
    }
    else if (controlName == 'currentStreetName' || controlName == 'permanentStreetName') {
      return "No special characters allowed"
    }
    else if (controlName == 'currentArea' || controlName == 'permanentArea') {
      return "No special characters allowed"
    }
    else if (controlName == 'currentLandmark' || controlName == 'permanentLandmark') {
      return "No special characters allowed"
    }
    else if (controlName == 'amount') {
      return "Please enter Numeric values"
    }
    else if (controlName == 'variant') {
      return "Please enter vaild Variant"
    }
    else {
      return "Pattern mismatch."
    }

  }

  getMinLengthErrorMessage(controlName) {
    if (controlName == 'primaryMobilePhone' || controlName == 'otherMobilePhone' || controlName == 'mobilePhone1' || controlName == 'mobilePhone2') {
      return "Please enter a 10 digit phone number"
    }

    if (controlName == 'organisationName') {
      return "Please enter minimum of 6 characters"
    }
    if (controlName == 'aadhar') {
      return "Please enter 12 digit Aadhar number"
    }
    if (controlName == 'designation') {
      return "Please enter minimum of 2 characters"
    }
    else if (controlName == 'currentPinCode' || controlName == 'permanentPinCode') {
      return "Please enter 6 digit pincode."
    }
    if (controlName == 'panNumber' || controlName == 'confirmPANNumber') {
      return "Please enter 10 digit PAN"
    }
    else if (controlName == 'contactPerson') {
      return "Please enter minimum of 4 characters"
    }
    else if (controlName == 'subvention' || controlName == 'additionalSubvention') {
      return "Not in Range allowed by Financial Product/Special Program"
    }
    else if (controlName == 'officeStreetName' || controlName == 'officeBuildingNo' || controlName == 'permanentBuildingNo' || controlName == 'permanentStreetName' || controlName == 'currentBuildingNo' || controlName == 'currentStreetName') {
      return "Please enter minimum 10 characters"
    }
    else {
      return "Please enter minimum number of characters."
    }
  }


  // Validate form instance
  // check_dirty true will only emit errors if the field is touched
  // check_dirty false will check all fields independent of
  // being touched or not. Use this as the last check before submitting
  public validateForm(formToValidate: FormGroup, formErrors: any, checkDirty?: boolean) {
    let form = formToValidate;

    for (let field in formErrors) {
      if (field) {
        formErrors[field] = '';
        const control = form.get(field);
        const messages = this.validationMessages(field);
        if (control && !control.valid) {
          if (!checkDirty || (control.dirty || control.touched)) {
            for (const key in control.errors) {
              if (key) {
                formErrors[field] = formErrors[field] || messages[key];
              } else {
                formErrors[field] = formErrors[field] || messages[key](control.errors[key]);
              }
            }
          }
        }
      }
    }
    return formErrors;

  }

  validateAmount(control: FormControl, formErrors: any, fieldName: string, isTouched: boolean) {
    if (control.errors && control.errors['positiveAmount']) {
      formErrors[fieldName] = 'Amount must be greater than 0.';
    } else {
      formErrors[fieldName] = '';
    }
  
    return formErrors;
  }
  

  public validateField(formcontrol: FormControl, formErrors: any, controlName: string, checkDirty?: boolean) {
    for (let field in formErrors) {
      if (field) {
        if (formcontrol && controlName == field) {
          formErrors[field] = '';
          const messages = this.validationMessages(field);
          if (!formcontrol.valid) {
            if (!checkDirty || (formcontrol.dirty || formcontrol.touched)) {
              for (const key in formcontrol.errors) {
                if (key) {
                  formErrors[field] = formErrors[field] || messages[key];
                } else {
                  formErrors[field] = formErrors[field] || messages[key](formcontrol.errors[key]);
                }
              }
            }
          }
        }
      }
    }
    return formErrors;
  }
}




